import { apiClient } from '../api';
import { Path } from '../api/backendUrl';
import { logError } from '../utils/logger';

export const reverseGeocode = async (lat: number, lng: number) => {
  try {
    const res = await apiClient.get(
      `${import.meta.env.VITE_APP_BACKEND_SERVICE}/${Path.reverseGeocode}?lat=${lat}&lon=${lng}`
    );
    return res.data;
  } catch (error) {
    logError('Error fetching reverse geocode:', { error });
    throw error;
  }
};

export const autoComplete = async (text: string) => {
  try {
    const res = await apiClient.get(
      `${import.meta.env.VITE_APP_BACKEND_SERVICE}/${Path.autoComplete}?searchText=${encodeURIComponent(text)}`
    );
    return res.data;
  } catch (error) {
    logError('Error fetching autocomplete:', { error });
    throw error;
  }
};
